export default __webpack_public_path__ + "static/media/zee_land_banner.52bce09b.png";